import { render, staticRenderFns } from "./EventCode.vue?vue&type=template&id=88eed838&scoped=true"
import script from "./EventCode.vue?vue&type=script&lang=js"
export * from "./EventCode.vue?vue&type=script&lang=js"
import style0 from "./EventCode.vue?vue&type=style&index=0&id=88eed838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eed838",
  null
  
)

export default component.exports